import clsx from "clsx";
import NavigationContext from "context/NavigationContext";
import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectThemeDirection } from "redux/theme/theme.selectors";
import { createStructuredSelector } from "reselect";
import jwtService from "services/jwtService";
import { CookieUtils } from "utils";
import DashboardNavigation from "../../../../components/DashboardNavigation/DashboardNavigation";
import Sidebar from "../../../../components/Sidebar/Sidebar";
import "./RightSidebar.scss";

const RightSidebar = () => {
  const { openDrawer } = React.useContext(NavigationContext);
  const { t } = useTranslation();

  const { themeDirection } = useSelector(
    createStructuredSelector({
      themeDirection: selectThemeDirection,
    })
  );

  return (
    <div className="cu-parent-sidebar">
      <Sidebar
        className={clsx(
          "cu-bg-blue-dark py-3 position-fixed",
          !openDrawer &&
            (themeDirection === "rtl" ? "close-drawer-rtl" : "close-drawer"),
          themeDirection === "rtl" ? "right-0" : "left-0"
        )}
      >
        <DashboardNavigation />
        <Button
          variant="danger"
          onClick={() => {
            localStorage.clear();
            CookieUtils.removeCookie();
            jwtService.logout();
            window.location.href = process.env.REACT_APP_SSO_LOGIN;
          }}
          className="w-75 text-white d-flex mx-auto justify-content-center my-2"
        >
          {t("exit")}
        </Button>
      </Sidebar>
    </div>
  );
};

export default RightSidebar;
